import { render, staticRenderFns } from "./CrmEditFileEvent.vue?vue&type=template&id=9795acec"
import script from "./CrmEditFileEvent.vue?vue&type=script&lang=ts"
export * from "./CrmEditFileEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9795acec')) {
      api.createRecord('9795acec', component.options)
    } else {
      api.reload('9795acec', component.options)
    }
    module.hot.accept("./CrmEditFileEvent.vue?vue&type=template&id=9795acec", function () {
      api.rerender('9795acec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/edit/CrmEditFileEvent.vue"
export default component.exports